import { render, staticRenderFns } from "./BottomNavigation.vue?vue&type=template&id=82e65b58&scoped=true"
import script from "./BottomNavigation.vue?vue&type=script&lang=ts"
export * from "./BottomNavigation.vue?vue&type=script&lang=ts"
import style0 from "./BottomNavigation.vue?vue&type=style&index=0&id=82e65b58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e65b58",
  null
  
)

export default component.exports